import styled from 'styled-components';
import { TypographyStyles, colours, media, zIDmeTooltip } from '../../../../../stylings';

export const TooltipContainer = styled.div`
  align-items: center;
  display: flex;
`;
export const IDmeTooltipIcon = styled.button`
  align-items: center;
  background: none;
  border: 0;
  display: flex;
  height: 24px;
  justify-content: center;
  margin: 0;
  padding: 0;
  width: 24px;
`;
export const IDmeTooltipBubble = styled.div`
  background: ${colours.WHITE};
  filter: drop-shadow(0 0 1px ${colours.BLACK});
  padding: 20px;
  top: 100%;
  width: 230px;
  z-index: ${zIDmeTooltip};

  &[data-popper-placement^='top'] > .arrow {
    bottom: 10px;
  }

  &[data-popper-placement^='bottom'] > .arrow {
    top: 10px;
  }

  &[data-popper-placement^='left'] > .arrow {
    right: 30px;
  }

  &[data-popper-placement^='right'] > .arrow {
    left: 10px;
  }

  @media ${media.greaterThan('lg')} {
    width: 300px;
  }
`;
export const IDmeTooltipArrow = styled.div`
  margin-left: -20px;
  position: absolute;
  z-index: ${zIDmeTooltip};

  &:before {
    border: 20px solid transparent;
    border-bottom: 30px solid ${colours.WHITE};
    border-top: 0;
    bottom: 0;
    content: '';
    position: absolute;
  }
`;
export const IDmeTooltipContent = styled.div`
  ${TypographyStyles.Body.Tiny.Regular}
`;
